import React from "react";
import { Table, Tag, Button, Pagination } from "antd";
import { ArrowUpRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const getStatusClass = (status) => {
  switch (status) {
    case "ACTIVE":
      return "text-green-700";

    case "IN_PROGRESS":
      return "text-yellow-700";

    case "COMPLETED":
      return "text-blue-700";

    default:
      return "text-gray-700";
  }
};

const BatchTable = ({
  allBatchData,
  pageCount,
  currentPage,
  onPageChange,
  pageSize,
  getAllBatch,
}) => {
  const navigate = useNavigate();

  const columns = [
    {
      title: (
        <span className="text-[#475467] font-medium text-[.8rem]">
          Batch Name
        </span>
      ),
      dataIndex: "batchName",
      key: "batchName",

      // left aligned
      render: (text, record) => (
        <div className="">
          <p
            onClick={() => {
              navigate(`/org-admin/batches/${record?.batchIdentifier}`);
            }}
            className="font-semibold cursor-pointer  text-gray-800  mb-0 text-[.85rem] hover:text-[#DC6803] transition-all duration-200 ease-in-out"
          >
            {text}
          </p>
          <p className="text-gray-400 text-[.78rem]  ">
            {record?.batchIdentifier}
          </p>
        </div>
      ),
    },

    {
      title: (
        <div className="text-center text-[#475467] font-medium text-[.8rem]">
          Tags
        </div>
      ),
      dataIndex: "tags",
      key: "tags",
      align: "center",

      render: (tags) => {
        const visibleTags = tags.slice(0, 3);
        const remainingCount = tags.length - 3;

        return (
          <div className="flex flex-wrap justify-center gap-[2px]">
            {visibleTags.map((tag) => (
              <Tag
                key={tag}
                className="rounded-md px-2 !py-[1px] !border-gray-200 !bg-gray-50 !text-gray-700"
              >
                {tag}
              </Tag>
            ))}

            {remainingCount > 0 && (
              <Tag className="rounded-md px-2 !py-[1px] !border-gray-200 !bg-gray-100 !text-gray-600">
                +{remainingCount}
              </Tag>
            )}
          </div>
        );
      },
    },

    {
      title: (
        <div className="text-center text-[#475467] font-medium text-[.8rem]">
          No. of Students
        </div>
      ),
      dataIndex: "candidateCount",
      key: "candidateCount",
      align: "center",

      render: (count) => (
        <span className="font-normal text-[#475467] text-[.8rem]">{count}</span>
      ),
    },

    {
      title: (
        <div className="text-center text-[#475467] font-medium text-[.8rem]">
          Created On
        </div>
      ),
      dataIndex: "creationDate",
      key: "creationDate",
      align: "center",

      render: (date) => (
        <span className="text-[#475467] font-normal text-[.8rem]">
          {new Date(date).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })}
        </span>
      ),
    },

    {
      title: (
        <div className="text-center text-[#475467] font-medium text-[.8rem]">
          Status
        </div>
      ),
      dataIndex: "status",
      key: "status",
      align: "center",

      render: (status) => (
        <span
          className={`inline-flex items-center gap-[7px] rounded-md border-[1px] border-gray-300 px-2 py-[3px] text-[.8rem] font-medium ${getStatusClass(
            status,
          )}`}
        >
          <span className="w-[.42rem] h-[.42rem] rounded-full bg-current"></span>
          {status
            .toLowerCase()
            .replace("_", " ")
            .replace(/\b\w/g, (char) => char.toUpperCase())}
        </span>
      ),
    },

    {
      title: (
        <div className="text-center text-[#475467] font-medium text-[.8rem]">
          Action
        </div>
      ),
      key: "action",
      align: "center",

      render: (_, record) => (
        <span
          className="text-[#DC6803] hover:brightness-[1.3] transition-all duration-200 cursor-pointer font-semibold flex items-center justify-center text-[.8rem] gap-1"
          onClick={() => {
            navigate(`/org-admin/batches/${record?.batchIdentifier}`);
          }}
        >
          View Batch <ArrowUpRight size={15} />
        </span>
      ),
    },
  ];

  const handlePageChange = (page) => {
    onPageChange(page);
  };

  return (
    <>
      <div className="rounded-2xl bg-white shadow-sm">
        <Table
          columns={columns}
          dataSource={allBatchData?.b2BCandidateBatchList}
          rowKey="uniqueId"
          pagination={false}
          scroll={{ x: 1100 }}
        />
      </div>
      <div className="flex justify-center mt-4 mb-1">
        <Pagination
          current={currentPage + 1}
          total={pageCount}
          pageSize={pageSize}
          onChange={onPageChange}
          showSizeChanger={true} // ✅ enable page size selector
          pageSizeOptions={["5", "10", "15", "20"]} // options for items per page
        />
      </div>
    </>
  );
};

export default BatchTable;
